import { render, staticRenderFns } from "./modify.vue?vue&type=template&id=946fd6f6&scoped=true"
import script from "./modify.vue?vue&type=script&lang=js"
export * from "./modify.vue?vue&type=script&lang=js"
import style0 from "./modify.vue?vue&type=style&index=0&id=946fd6f6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946fd6f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\iotcarduserui\\iotcardpc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('946fd6f6')) {
      api.createRecord('946fd6f6', component.options)
    } else {
      api.reload('946fd6f6', component.options)
    }
    module.hot.accept("./modify.vue?vue&type=template&id=946fd6f6&scoped=true", function () {
      api.rerender('946fd6f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modify/modify.vue"
export default component.exports